import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeurlPipe } from './safeurl.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [SafeurlPipe],
  exports: [SafeurlPipe],
})
export class SafeurlModule { }
